var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"page__title column is-12-mobile"},[_c('h1',{staticClass:"title has-text-grey-dark is-size-3-touch mb-0"},[(_vm.page == 'Dashboard' && _vm.user)?_c('span',[_vm._v("Olá, "+_vm._s(_vm.user.first_name)+"!")]):_c('span',[_vm._v(_vm._s(_vm.page))])]),_c('Breadcrumb')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }